import { render, staticRenderFns } from "./reading-list.vue?vue&type=template&id=6fa9231f&scoped=true&lang=pug&"
import script from "./reading-list.vue?vue&type=script&lang=js&"
export * from "./reading-list.vue?vue&type=script&lang=js&"
import style0 from "./reading-list.vue?vue&type=style&index=0&id=6fa9231f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa9231f",
  null
  
)

export default component.exports